<template>
  <div :class="prefixCls">
    <div
      ref="editor"
      class="editor-wrapper"
    ></div>
  </div>
</template>

<script>
import WEditor from 'wangeditor';
import Vue from 'vue';
import axios from '@/api/axios';
import { urls } from '@/api/urls';

export default {
  name: 'WangEditor',
  props: {
    prefixCls: {
      type: String,
      default: 'ant-editor-wang'
    },
    // eslint-disable-next-line
    value: {
      type: String
    }
  },
  data () {
    return {
      editor: null,
      editorContent: null
    };
  },
  watch: {
    value (val) {
      this.editorContent = val;
      this.editor.txt.html(val);
    }
  },
  mounted () {
    this.initEditor();
  },
  methods: {
    initEditor () {
      this.editor = new WEditor(this.$refs.editor);
      this.editor.customConfig.onchange = html => {
        this.editorContent = html;
        this.$emit('change', this.editorContent);
      };
      this.editor.customConfig.uploadImgServer = process.env.NODE_ENV == 'development' ? '/proxyApi/SvpUpload' : '/SvpUpload';
      this.editor.customConfig.uploadImgMaxSize = 1 * 1024 * 1024;
      this.editor.customConfig.uploadImgMaxLength = 5;
      this.editor.customConfig.pasteTextHandle = function (content) {
        var reg = /style\s*?=\s*?(['"])[\s\S]*?\1/;
        if (content == '' && !content) return ''
        var str = content
        str = str.replace(/<xml>[\s\S]*?<\/xml>/ig, '')
        str = str.replace(/<style>[\s\S]*?<\/style>/ig, '')
        str = str.replace(/<\/?[^>]*>/g, '')
        str = str.replace(/[ | ]*\n/g, '\n')
        str = str.replace(/&nbsp;/ig, '')
        console.log('****', content)
        console.log('****', str)
        return str
      }
      this.editor.customConfig.customUploadImg = function (files, insert) {
        let param = new FormData(); // 创建form对象
        files.forEach(file => {
          param.append('fileName', file); // 通过append向form对象添加数据
          param.append('chunk', '0'); // 添加form表单中其他数据

          axios
            .post(process.env.NODE_ENV == 'development' ? '/proxyApi/SvpUpload' : '/SvpUpload', param, {
              header: {
                'Content-Type': 'multipart/form-data'
              },
              onUploadProgress: progressEvent => {
                let complete = (((progressEvent.loaded / progressEvent.total) * 100) | 0) + '%';
                this.uploadProgress = complete;
              }
            })
            .then(resp => {
              if (resp.data.code == 0) {
                insert((process.env.NODE_ENV == 'development' ? urls.picUrl : urls.picUrl2) + resp.data.fileName);
              }
            });
        });
      };

      this.editor.customConfig.uploadImgHeaders = {
        'Content-Type': 'multipart/form-data',
        token: Vue.ls.get('token')
      };
      this.editor.customConfig.menus = [ // 菜单配置
        'head', // 标题
        'bold', // 粗体
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'image', // 插入图片
        'table', // 表格
        'code', // 插入代码
        'undo', // 撤销
        'redo' // 重复
      ]
      this.editor.create();
    },
    insertValue (value) {
      this.editor.cmd.do('insertHtml', value);
    },

    initValue (value) {
      this.editor.txt.html(value);
    },

    setValue (val) {
      this.value = val;
    },

    clear () {
      this.value = '';
    },

    getValue () {
      return this.editorContent;
    }
  }
};
</script>

<style>
.w-e-text-container {
  /* height: 700px !important; */
}
</style>

<style lang="less" scoped>
.ant-editor-wang {
  .editor-wrapper {
    text-align: left;
  }
}
</style>
